<template>
  <Page :page-name="pageName" :table="table" :pagination="pagination" :search-bar="searchBar" 
  v-loading="loading" element-loading-text="数据加载中" element-loading-background="rgba(255, 255, 255, 0.5)">

    <template slot="table-operate" slot-scope="{scope}">
      <div style="display: flex;justify-content: center;">
        <el-button type="text" :disabled="approveState(scope)"   @click="edit(scope,1)">
          审批
        </el-button>

        <el-button type="text" :disabled="orderState(scope)"  @click="edit(scope,2)">
          回单
        </el-button>

      </div>
    </template>

    <template slot="pointCheck" slot-scope="{scope}">
      <span @click="edit(scope,3)" style="cursor: pointer;color:#00af84;">查看</span>
    </template>
    <template slot="status" slot-scope="{scope}">
      <span>{{ statusText(scope.status) }}</span>
    </template>
    <template slot="recycleImages" slot-scope="{scope}">
      <div>
        <el-image style="width: 59px; height: 34px" :src="scope.recycleImages[0]" :preview-src-list="scope.recycleImages"></el-image>
      </div>
    </template>
    <Dialogs :title="title" :is-show-dialog="isShowPage" width="35%" @handleClick="handleClose" :enterEvent="clickPage" :noBorderTop="noBorderTop">
      <div slot="content">
        <AccoutDetail
          ref="accountDetailRef"
          :row-form="rowData"
          :pageFlag="pageFlag"
        />
      </div>
      <div slot="btns">
          <el-button v-if="pageFlag==1" @click="cancel(0)" style="margin-right: 20px;">取消</el-button>
          <el-button v-if="pageFlag!=3" :type="this.pageFlag==2?'default':'danger'" @click="cancel(2)" style="margin-right: 20px;">{{this.pageFlag==2?'取消':'拒绝'}}</el-button>
          <el-button v-if="pageFlag!=3" type="primary" @click="clickPage(1)">{{this.pageFlag==2?'保 存':'通过'}}</el-button>
      </div>
    </Dialogs>

  </Page>
</template>

<script>
import Page from '@/components/Page2.vue'
import AccoutDetail from './accoutDetail'
import {getRecycleOrderList, getRecycleOrderTypeList, approve, getRecycleOrderDetail} from '@/api/recyclingForm'
import Dialogs from '@/components/page/Dialogs.vue'
import mixin from '@/utils/mixin'
import {isValidPhoneNumber} from '@/utils/index'

export default {
  name: 'Account',
  components: {
    AccoutDetail,
    Page,
    Dialogs
  },
  props: {
    status: [Number, String]
  },
  mixins: [mixin],
  data () {
    return {
      pageName: '回收单',
      table: {
        selection: false, // 是否开启选择框
        tableInfo: [{
          key: 'num',
          name: '序号',
          minWidth: 60
        }, {
          key: 'recycleNo',
          name: '单号',
          minWidth: 100
        }, {
          key: 'userName',
          name: '会员名称',
          minWidth: 60
        }, {
          key: 'phone',
          name: '会员电话',
          minWidth: 60
        }, {
          key: 'typeNames',
          name: '回收类型',
          minWidth: 60
        }, {
          key: 'recycleImages',
          name: '图片',
          minWidth: 80,
          hideTooltip: true,
          type: 'custom'
        }, {
          key: 'createTime',
          name: '发起时间'

        }, {
          key: 'status',
          name: '状态',
          minWidth: 80,
          type: 'custom'
        }, {
          key: 'pointCheck',
          name: '回单',
          width: 80,
          type: 'custom'
        }],
        tableData: [],
        deleteItem: () => {}
      },

      searchBar: {
        list: [{
          type: 'input',
          prop: 'recycleNo',
          label: '单号',
          placeholder: '请输入'
        }, {
          type: 'input',
          prop: 'userName',
          label: '名称',
          placeholder: '请输入'
        }, {
          type: 'input',
          prop: 'phone',
          label: '电话',
          placeholder: '请输入'
        }, {
          type: 'select',
          prop: 'typeId',
          label: '类型',
          options: [],
          placeholder: '请选择'
        },
        // {
        //   type: 'select',
        //   prop: 'status',
        //   label: '状态',
        //   options: [{
        //     label: '待审批',
        //     value: '0'
        //   },
        //   {
        //     label: '待回收',
        //     value: '1'
        //   },
        //   {
        //     label: '已驳回',
        //     value: '2'
        //   },
        //   {
        //     label: '已完成',
        //     value: '3'
        //   }
        //   // {
        //   //   label: '全部',
        //   //   value: '4'
        //   // }
        //   ],
        //   placeholder: '请选择'
        // },
        {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: this.searchBarform
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      },
      userName: '',
      recycleNo: '',
      deviceTypeId: '',
      phone: '',
      typeId: '',
      loading: false,
      pageFlag: ''
    }
  },
  computed: {
    params () {
      return {
        current: this.pagination.currentPage,
        size: this.pagination.size,
        userName: this.userName,
        recycleNo: this.recycleNo,
        phone: this.phone,
        status: this.status,
        typeId: this.typeId
      }
    },
    title () {
      return this.pageFlag === 1 ? '审批' : this.pageFlag === 2 ? '回单' : '查看回单'
    },
    statusText () {
      return (val) => {
        const obj = {0: '待审批', 1: '待回收', 2: '已驳回', 3: '已完成'}
        return obj[val]
      }
    },
    approveState () {
      return (row) => {
        const status = +row.status
        return [1, 2, 3].includes(status)
      }
    },
    orderState () {
      return (row) => {
        const status = +row.status
        return ![1].includes(status)
      }
    },
    noBorderTop () {
      return this.pageFlag == 3
    }
  },
  watch: {
    params () {
      this.getUserList()
    }
  },
  created () {
    this.getUserList()
    this.getRecycleOrderTypeList()
  },
  methods: {
    getUserList () {
      this.loading = true
      const params = this.params
      getRecycleOrderList(params).then(({success, data}) => {
        if (success) {
          const {records, total} = data
          this.pagination.total = total
          this.table.tableData = records

          this.table.tableData.forEach((item, idx) => {
            item.num = (this.pagination.currentPage - 1) * this.pagination.size + idx + 1
          })
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getRecycleOrderTypeList () {
      getRecycleOrderTypeList().then(({success, data}) => {
        if (success) {
          const list = data.map((item) => ({
            label: item.typName,
            value: item.typeId
          }))
          this.$set(this.searchBar.list[3], 'options', list)
        }
      })
    },

    edit (row, pageflag) {
      this.pageFlag = pageflag  // 1审批 2回单编辑  3查看（回单编辑只读）

      if (+pageflag === 3) {
        this.recycleOrderDetail(row.id)
      } else {
        this.rowData = JSON.parse(JSON.stringify(row))
        this.isShowPage = true
      }
    },
    recycleOrderDetail (recycleId) {
      getRecycleOrderDetail({recycleId}).then(({success, data}) => {
        if (success) {
          this.rowData = Object.assign({}, data)
          this.isShowPage = true
        }
      }).catch(() => {
        this.rowData = {}
      })
    },
    cancel (status) {
      console.log('status', status)
      this.isShowPage = false
      this.rowData = null
      if (status) this.clickPage(status)
    },
    clickPage (status) {
      if (this.pageFlag === 3) return
      const data = this.$refs.accountDetailRef.rowData
      const fileList = this.$refs.accountDetailRef.fileList
      const refForm = this.$refs.accountDetailRef.$refs.rowForm
      refForm.validate((valid) => {
        if (valid) {
          const {
            id,
            pointNum
            } = data
          const params = this.pageFlag === 1 ? {
            id,
            status
          } : {
            recycleId: id,
            point: pointNum,
            files: fileList
          }

          if (this.pageFlag === 1) {
            approve(params).then(({success}) => {
              if (success) {
                this.$message({
                  type: 'success',
                  message: `发送成功`
                })
              }
            })
          } else {
            this.$refs.accountDetailRef.submitFileForm()
          }
          this.T = setTimeout(() => {
            this.getUserList()
            clearTimeout(this.T)
          }, 600)
          this.cancel()
        }
      })
    },
    searchBarform (params) {
      this.ms && this.ms.close()
      const obj = {...this.params, ...params, userName: params.userName.trim(), recycleNo: params.recycleNo.trim()}
      const {userName, recycleNo} = obj
      if ((userName && userName.length > 20) || (recycleNo && recycleNo.length > 20)) {
        this.ms = this.$message({
          type: 'warning',
          message: '搜索的长度不能超过20字'
        })
        return
      }

      if (obj.phone && !isValidPhoneNumber(obj.phone)) {
        this.ms = this.$message({
          type: 'warning',
          message: '请输入正确的手机号'
        })
        return
      }

      this.recycleNo = obj.recycleNo
      this.userName = obj.userName
      this.phone = obj.phone
      this.typeId = obj.typeId
      this.pagination.currentPage = 1
    },
    clearParams () {
      this.recycleNo = ''
      this.userName = ''
      this.phone = ''
      this.typeId = ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__header {
  th:nth-child(10){
    // padding-right: 26px;
  }
}
</style>

